export const getAllCampaign = () => ({
  type: 'GET_ALL_CAMPAIGNS',
});
export const getAllInboxes = (payload) => ({
  type: 'GET_ALL_INBOXES',
  payload,
});
export const getAllMails = (payload) => ({
  type: 'GET_ALL_MAILS',
  payload,
});
export const getAllEmailCampaign = () => ({
  type: 'GET_ALL_EMAIL_CAMPAIGNS',
});
export const setAllCampaign = (data) => ({
  type: 'SET_ALL_CAMPAIGNS',
  payload: data,
});
export const setAllInboxes = (data) => ({
  type: 'SET_ALL_INBOXES',
  payload: data,
});
export const setAllMails = (data) => ({
  type: 'SET_ALL_MAILS',
  payload: data,
});
export const getSingleTask = (data) => ({
  type: 'GET_SINGLE_CAMPAIGN',
  payload: data,
});

export const setSingleTask = (data) => ({
  type: 'SET_SINGLE_TASK',
  payload: data,
});

export const getCampaignLogs = (data) => ({
  type: 'GET_CAMPAIGN_LOGS',
  payload: data,
});

export const setCampaignLogs = (data) => ({
  type: 'SET_CAMPAIGN_LOGS',
  payload: data,
});

export const deleteSingleCampaign = (data) => ({
  type: 'DELETE_SINGLE_CAMPAIGN',
  payload: data,
});

export const updateStatus = (data) => ({
  type: 'UPDATE_STATUS',
  payload: data,
});

export const createTask = ({ data, successCallback, failCallback }) => ({
  type: 'CREATE_CAMPAIGN',
  payload: {
    formData: data,
    successCallback,
    failCallback
  }
})
export const registerGAccounts = ({ data, successCallback, failCallback }) => ({
  type: 'CREATE_ACCOUNT',
  payload: {
    formData: data,
    successCallback,
    failCallback
  }
})
export const replyToUserEmail = ({ data, successCallback, failCallback }) => ({
  type: 'SEND_USER_EMAIL',
  payload: {
    formData: data,
    successCallback,
    failCallback
  }
})
export const registerAppPassAccounts = ({ data, successCallback, failCallback }) => ({
  type: 'CREATE_APP_PASSWORD_ACCOUNT',
  payload: {
    formData: data,
    successCallback,
    failCallback
  }
})
export const createEmailTask = ({ data, successCallback, failCallback }) => ({
  type: 'CREATE_EMAIL_CAMPAIGN',
  payload: {
    formData: data,
    successCallback,
    failCallback
  }
})
export const updateTask = ({ id, data, successCallback, failCallback }) => ({
  type: 'UPDATE_CAMPAIGN',
  payload: {
    id,
    formData: data,
    successCallback,
    failCallback
  }
})

export const editTask = ({ data, id }) => ({
  type: 'EDIT_CAMPAIGN',
  payload: data,
  id
});

export const createScheduleEmail = ({ data, successCallback, failCallback , campaignId}) => ({
  type: 'SET_EMAIL_SCHEDULE',
  payload: {
    formData: data,
    successCallback,
    failCallback,
    campaignId
  }
})